import { createStore, applyMiddleware } from 'redux'
import { createLogger } from 'redux-logger'
import createSagaMiddleware from 'redux-saga'
import { composeWithDevTools } from '@redux-devtools/extension'
import reducers from './modules'
import allSagas from './sagas'

const sagaMiddleware = createSagaMiddleware()

const logger = createLogger()
const applyableMiddleware = import.meta.env.PROD ? [sagaMiddleware] : [sagaMiddleware, logger]

const middleware = applyMiddleware(...applyableMiddleware)

const store = createStore(reducers, composeWithDevTools(middleware))

sagaMiddleware.run(allSagas)

export default store
